/**
 * Wrapper classes and custom properties for Medal.
 *
 * Shared by edit.jsx and save.jsx so the editor preview and the saved markup
 * cannot drift — a static-save block that computes its wrapper twice is the
 * classic source of "block contains unexpected content" validation errors.
 */

import { resolvePresetValue } from '../../utils/helpers';

/**
 * @param {Object} attributes Block attributes.
 * @return {string} Wrapper class list.
 */
export function getWrapperClasses(attributes) {
  const { shape } = attributes;

  return ['brandy-medal', shape && shape !== 'none' ? `has-shape-${shape}` : '']
    .filter(Boolean)
    .join(' ');
}

/**
 * Both colours are custom properties rather than inline `color` declarations.
 *
 * The shapes paint from `currentColor`, so an inline colour set on the wrapper
 * to tint them would drag the caption and every inner block along with it —
 * which is the whole reason the caption gets a property of its own. Each lands
 * on the element that needs it and nothing inherits a colour by accident.
 *
 * @param {Object} attributes Block attributes.
 * @return {Object} React style object.
 */
export function getWrapperStyles(attributes) {
  const { shapeSize, shapeColor, shapeGap, labelColor } = attributes;

  const styles = {
    '--brandy-medal-shape-size': `${shapeSize}px`,
    '--brandy-medal-shape-gap': `${shapeGap}px`,
  };

  if (shapeColor) {
    styles['--brandy-medal-shape-color'] = resolvePresetValue(shapeColor);
  }

  if (labelColor) {
    styles['--brandy-medal-label-color'] = resolvePresetValue(labelColor);
  }

  return styles;
}
